import * as XLSX from 'xlsx-js-style';

/**
 * 通过传入的columns和data，生成符合xlsx插件方法的数据
 */
function _transformDataByColumns (data, columns, config) {
  return [
    columns.map(col => ({
      v: col.title,
      t: 's',
      s: config.headerStyle || getDefaultHeaderStyle()
    })),
    ...data.map((row, rowIndex) => columns.map((cell) => {
      const value = row[cell.dataIndex] || '';
      return {
        v: value,
        t: typeof value === 'number' ? 'n' : 's',
        s: typeof cell.styleCB === 'function' ? cell.styleCB(value, row, rowIndex - 1) : {}
      }
    }))
  ];
}

export function getDefaultHeaderStyle () {
  return {
    // font 字体属性
    font: {
      bold: true,
      sz: 14
    },
    // alignment 对齐方式
    alignment: {
      vertical: 'center', // 垂直居中
      horizontal: 'center', // 水平居中
      wrapText: true // 单元格包裹文本，自动扩大行高
    },
    // fill 颜色填充属性
    fill: {
      fgColor: { rgb: 'C0C0C0' }
    },
    // border 边框属性
    border: {
      bottom: { color: { rgb: '000000' }, style: 'thin' },
      right: { color: { rgb: '000000' }, style: 'thin' }
    }
  };
}

/**
 * # 根据传入的表格数据以及列配置，导出excel文件
 * ## 列配置(columns)
 * | 属性 | 说明 | 类型 | 默认值 |
 * | --- | --- | --- | --- |
 * | title | 表头名 | String | |
 * | dataIndex | 字段名 | String | |
 * | width | 列宽 | Number | |
 * | styleCB | 样式回调，返回值参考[xlsx-js-style组件](https://www.npmjs.com/package/xlsx-js-style) | (value, record, rowIndex) => Object | |
 * ---------------------
 * ## 全局配置(config)
 * | 属性 | 说明 | 类型 | 默认值 |
 * | --- | --- | --- | --- |
 * | headerHeight | 表头高度 | Number | |
 * | headerStyle | 描述头部样式的对象。可以使用**getDefaultHeaderStyle**方法获得默认样式 | [xlsx-js-style组件](https://www.npmjs.com/package/xlsx-js-style)的样式对象 | 该表格下方展示 |
 * <pre>
 * headerStyle默认值：{
 *   // font 字体属性
 *   font: {
 *      bold: true,
 *      sz: 14,
 *    },
 *    // alignment 对齐方式
 *    alignment: {
 *      vertical: 'center', // 垂直居中
 *      horizontal: 'center', // 水平居中
 *      wrapText: true // 单元格包裹文本，自动扩大行高
 *    },
 *    // fill 颜色填充属性
 *    fill: {
 *      fgColor: { rgb: 'C0C0C0' },
 *    },
 * }
 *  </pre>
 * @param {Array<Object>} data 对象数组
 * @param {Array<{
 *   title: String,
 *   dataIndex: String,
 *   width?: Number,
 *   styleCB?: (value: String | Number, record: Object, rowIndex: Number) => Object
 * }>} columns 列配置文件名
 * @param {String} fileName 导出文件名
 * @param {{headerHeight?: Number, headerStyle?: Object}} config 表格整体配置
 * @author 晓蟲
 */
export function json2xlsx (data = [], columns = [], fileName = '导出数据.xlsx', config = {}) {
  const ws = XLSX.utils.aoa_to_sheet(_transformDataByColumns(data, columns, config));

  ws['!cols'] = columns.map(col => ({ wpx: col.width || 100 }));
  ws['!rows'] = [{ hpx: config.headerHeight }];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "sheet1");
  XLSX.writeFile(wb, fileName);
}
